import { Component, OnInit, ViewChild, ElementRef, NgZone } from '@angular/core';
import { DoctorsService } from '../shared/doctor-service/doctors.service';
import { FormControl, FormGroup } from '@angular/forms';
import { Router, NavigationExtras } from '@angular/router';
import { PatientService } from '../shared/patient-service/patient.service';
import { async } from '@angular/core/testing';
import { AuthService } from 'src/app/auth-section/auth-service/auth.service';
@Component({
  selector: 'app-landing-page',
  templateUrl: './landing-page.component.html',
  styleUrls: ['./landing-page.component.css']
})
export class LandingPageComponent implements OnInit {
  CityDoctor: any;
  path: any;
  curindex: any;
  City: any;
  count = 12;
  navigationExtras: any;
  authData: any;
  token: any;
  docData: any;
  profileImage: any;
  islogIn: boolean = false;
  cities: any;
  servicesArray = [];
  type: string;
  texts: string[] = [];
  userToken: string;
  id: string;
  page: number = 1;
  @ViewChild('cls', { static: false }) cref:ElementRef<HTMLButtonElement>;
  @ViewChild('clos', { static: false }) dref: ElementRef;
  constructor(private doctorService: DoctorsService, private router: Router, private patservice: PatientService, private authService: AuthService) { }

  ngOnInit(): void {
    if (localStorage.getItem('city')) {
      this.City = String(localStorage.getItem('city'))
    } else {
      this.City = "Najibabad"
    }
    this.getAlldoctors();
    this.getSingleDoctor();
  }

  getSingleDoctor() {
    if (this.type == 'DOCTOR') {
      this.doctorService.getSingleDoctorFromDb(this.id, this.userToken).subscribe(
        (res) => {
          this.docData = res;
          this.docData.experience = this.docData.experience
            ? this.docData.experience
            : 0;
          this.profileImage = 'https://api.doqmatokens.com/' + res.profileImage;
          if (res.services.length > 0) {
            this.texts = res.services;
            this.servicesArray = res.services;
          }
        },
        (error) => {
          console.log('error');
        }
      );
    } else {
      this.doctorService.getSinglereceptionist(this.id, this.userToken).subscribe(
        (res) => {
          this.docData = res;
          this.docData.experience = this.docData.experience
            ? this.docData.experience
            : 0;
          this.profileImage = 'https://api.doqmatokens.com/' + res.profileImage;
          // this.oninitForm();
          if (res.services.length > 0) {
            this.texts = res.services;
            this.servicesArray = res.services;
          }
        },
        (error) => {
          console.log('error');
          // this.oninitForm();
        }
      );
    }
  }
  getAlldoctors() {
    this.doctorService.getCityDoctor(this.City, this.count, this.page).subscribe(async (data: any) => {
      this.CityDoctor = data.data;
      this.CityDoctor.docs = await this.CityDoctor.docs.filter((value, index, self) =>
        index === self.findIndex((t) => (
          t.doctorId.name === value.doctorId.name
        ))
      )
      this.path = 'https://dev.api.doqmatokens.com/'
      console.log("this is city doctor data", this.path);
      console.log("this is doctor", data);
      //   this.cityForm = new FormGroup({
      //     name: new FormControl(this.City),
      //  });
    })
  }
  navigatetodoc(Id: any) {
    return window.location.href = 'https://p.doqmatokens.com/singledoctor/' + Id;
  }

  onLogOut() {
    // localStorage.clear();
    this.authService.ondashboardLogOut();
    this.islogIn = false;
    // this.getSingleDoctor();
  }

  findCity(data) {
    console.log("this CITY", data);
    this.patservice.getcity(data.target.value).subscribe((res: any) => {
      console.log("this is city", res);
      this.cities = res.res;
    })
  }

  onSubmit(city) {
    this.City = city;
    this.count = 10;
    this.doctorService.getCityDoctor(city, this.count, this.page).subscribe((item: any) => {
      this.closeNav();
      console.log("success", city);
      console.log("this is data of doctors", item);
      localStorage.setItem('city', city);
      this.getAlldoctors();
    });
  }
  
  sendDoctor(_id) {
    this.navigationExtras = {
      state: {
        transd: _id,       
      }
    };
    this.router.navigate(['viewdoctor', _id]);
  }

  closeMmodal() {
    if(this.cref){
      this.cref?.nativeElement.click();
      this.router.navigate(['/Market']);
    }
  }
  
  // Doqma@47934
  closeDmodal(){
    if(this.cref){
    this.cref?.nativeElement.click();
    this.router.navigate(['/auth'])
    }
  }

  openNav() {
    document.getElementById("mySidenav").style.width = "347px";
    document.body.style.backgroundColor = "rgba(0,0,0,0.4)";
  }

  closeNav() {
    document.getElementById("mySidenav").style.width = "0";
    document.getElementById("mySidenav").style.right = "-10";
    document.body.style.backgroundColor = "white";
  }
  closebtne() {
    document.getElementById("navbarResponsive").style.height = "0";
  }
  closemenu() {
    this.dref.nativeElement.click();
    console.log("this is console");
  }

  signIn() {
    window.location.href = "https://p.doqmatokens.com/patlog";
    this.closeDmodal();
  }
}